import React from 'react';
import { motion } from 'framer-motion';
export function PerspectiveShift() {
  return <motion.section initial={{
    opacity: 0
  }} whileInView={{
    opacity: 1
  }} viewport={{
    once: true
  }} className="py-16 px-4" data-id="element-115">
      <div className="max-w-3xl mx-auto text-center space-y-6" data-id="element-116">
        <h3 className="text-2xl md:text-3xl font-bold text-accent" data-id="element-117">
          Esta es la verdad que casi nadie te dice:
        </h3>

        <p className="text-xl md:text-2xl font-bold line-through text-gray-500" data-id="element-118">
          No se trata de ser mejor profesor.
        </p>

        <p className="text-2xl md:text-3xl font-black text-primary" data-id="element-119">
          Se trata de tener un mejor sistema para atraer, convertir y mantener
          alumnos.
        </p>
      </div>
    </motion.section>;
}